import { Formik } from 'formik'
import { debounce, isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import Card from '@/components/Card'
import { Text } from '@/components/Form'
import { Search } from '@/components/Icons'
import PaginationTable from '@/components/PaginationTable'

import columns from './columns'
import messages from './messages'

import './index.scss'

const defaultSort = {
  displayName: { direction: 'asc', position: 1 }
}

// in milliseconds
const searchDelay = 300

function GroupMembers(props: any) {
  const intl = useIntl()

  const [state, setState] = useState({
    filterValue: props.filterValue
  })

  useEffect(() => {
    if (!props.sortingColumn) {
      props.loadPage(
        1,
        Object.keys(defaultSort)[0],
        // @ts-expect-error
        defaultSort[Object.keys(defaultSort)[0]].direction.toUpperCase(),
        state.filterValue
      )
    }
  }, [props, state])

  const onSelect = (page: any, sort: any, sortBy: any) => {
    props.loadPage(page, sort, sortBy, state.filterValue)
  }

  const onFilterChange = (e: any) => {
    setState({ filterValue: e.target.value })

    if (!!props.sortingColumn && !isEmpty(props.sortingColumn)) {
      fetchFilterResults(
        1,
        Object.keys(props.sortingColumn)[0],
        props.sortingColumn[Object.keys(props.sortingColumn)[0]].direction.toUpperCase()
      )
    } else {
      fetchFilterResults(1)
    }
  }

  const fetchFilterResults = debounce((page: any, sort?: any, sortBy?: any) => {
    props.loadPage(page, sort, sortBy, state.filterValue)
  }, searchDelay)

  return (
    <Card
      className="group-members"
      isActionInProgress={props.isFetchingMembers && !state.filterValue}
      actionMessage={<FormattedMessage {...messages.loadingMembers} />}
    >
      <Card.Header title={props.group.displayName} />
      <Card.Content>
        <p>
          <FormattedMessage {...messages.description} />
        </p>
        <div className="member-search">
          {/* @ts-expect-error */}
          <Formik initialValues={{ search: state.filterValue }}>
            <Text
              icon={
                props.isFetchingMembers && state.filterValue ? <span className="field__icon--loading" /> : <Search />
              }
              name="search"
              onChange={onFilterChange}
              placeholder={intl.formatMessage(messages.search)}
            />
          </Formik>
        </div>

        {props.members.length > 0 || props.isFetchingMembers ? (
          <PaginationTable
            columns={columns({
              intl: intl
            })}
            pagination={{
              count: props.memberCount,
              startIndex: props.startIndex,
              perPage: props.perPage
            }}
            onPaginateSelect={onSelect}
            rows={props.members}
            rowItemType={<FormattedMessage {...messages.members} />}
            rowKey="id"
            sortingColumn={props.sortingColumn}
          />
        ) : (
          <p className="no-members flex-center">
            {state.filterValue === '' ? (
              <FormattedMessage {...messages.noMembers} />
            ) : (
              <FormattedMessage {...messages.noSearchMembers} />
            )}
          </p>
        )}
      </Card.Content>
    </Card>
  )
}

GroupMembers.displayName = 'GroupMembers'

GroupMembers.propTypes = {
  filterValue: PropTypes.string,
  group: PropTypes.object.isRequired,

  isFetchingMembers: PropTypes.bool,
  loadPage: PropTypes.func.isRequired,
  perPage: PropTypes.number.isRequired,
  sortingColumn: PropTypes.object,
  startIndex: PropTypes.number.isRequired,
  memberCount: PropTypes.number.isRequired,
  members: PropTypes.array
}

GroupMembers.defaultProps = {
  filterValue: '',
  isFetchingMembers: false,
  sortingColumn: null,
  members: []
}

export default GroupMembers
